var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.error.statusCode === 404)?_c('div',[_c('h1',[_vm._v("Page not found")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.error.message))])]):_c('div',[_c('h1',[_vm._v("An error occurred")])]),_vm._v(" "),_c('nuxt-link',{attrs:{"to":"/"}},[_vm._v("首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }